/*
 * @Author: COCO 
 * @Date: 2018-05-07 11:26:40 
 * @Last Modified by: COCO
 * @Last Modified time: 2018-08-06 14:17:08
 * 所有请求数据接口都通过api这个模块导出
 */

import hotSpotAnalysis from './hotSpotAnalysis';
import marketAPI from './market';

const api = {
  hotSpotAnalysis,
  marketAPI
};

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js